module.exports = __webpack_public_path__ + "static/media/settings.1303ab97.svg";